import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondChar',
  standalone: true,
})
export class SecondCharPipe implements PipeTransform {
  public transform(value: number | null): string {
    if (value === null || value <= 0) {
      return '0';
    }
    if (value < 10) {
      return `${value}`.charAt(0);
    }
    return `${value}`.charAt(1);
  }
}
